module.exports = __webpack_public_path__ + "img/ics_o_trash.9c2c2ed3.svg";